/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A1Inputs */

const et_faq_a1 = /** @type {(inputs: Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Mapsis esile tõusmine vajab kolme asja: optimeeritud Google Business Profile'i, järjepidevaid arvustusi ja tugevat kohalikku SEO-d kodulehel. ScalingWebs ühendab need osad üheks süsteemiks, et sinu ettevõte ilmuks nendele inimestele, kes otsivad sinu teenust praegu sinu piirkonnas. Meie töö hõlmab profiili optimeerimist, teenusepõhiseid maandumislehti, kohalikke märksõnu, tehnilist SEO-d ja päringutele suunatud sisu. Eesmärk on rohkem ostuvalmis päringuid, mitte lihtsalt rohkem liiklust.`)
};

const en_faq_a1 = /** @type {(inputs: Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standing out on Google Maps requires three things: an optimized Google Business Profile, consistent reviews, and strong local SEO on your website. ScalingWebs connects these parts into one system so your business appears to people already searching for your service in your area. Our work includes profile optimization, service-specific landing pages, local keywords, technical SEO, and inquiry-focused content. The goal is more purchase-ready inquiries, not just more traffic.`)
};

/**
* | output |
* | --- |
* | "Standing out on Google Maps requires three things: an optimized Google Business Profile, consistent reviews, and strong local SEO on your website. ScalingWeb..." |
*
* @param {Faq_A1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a1 = /** @type {((inputs?: Faq_A1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a1(inputs)
	return en_faq_a1(inputs)
});